import { LegalShell, Section } from "@/components/LegalShell";

export default function Cookies() {
  return (
    <LegalShell title="Cookie Notice" subtitle="Cookies" updated="February 2026">
      <Section title="What cookies we use">
        <p>SiteCrews uses only strictly-necessary cookies. No advertising or third-party tracking cookies are set.</p>
      </Section>
      <Section title="The cookies">
        <ul className="list-disc pl-6 space-y-1">
          <li><b>access_token</b> — httpOnly authentication cookie that keeps you logged in. Expires after 7 days. Cannot be disabled without breaking log-in.</li>
        </ul>
      </Section>
      <Section title="Payment processor cookies">
        <p>When you make a boost payment you are redirected to Stripe. Stripe may set its own cookies on its own domain to process the payment securely and prevent fraud. Those cookies are governed by <a className="text-amber-500 hover:underline" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe&apos;s cookie policy</a>.</p>
      </Section>
      <Section title="Managing cookies">
        <p>You can clear cookies in your browser settings at any time. Doing so will log you out.</p>
      </Section>
    </LegalShell>
  );
}
